module.exports = __webpack_public_path__ + "img/shield.18407fba.png";